import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import { sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import NavBar from '../Components/NavBar';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const processLink = async () => {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        const storedEmail = window.localStorage.getItem('adminEmailForSignIn');
        if (!storedEmail) {
          setError('Email verification data is missing. Request a new admin sign-in link.');
          setStatus('error');
          return;
        }

        setStatus('processing');
        try {
          await signInWithEmailLink(auth, storedEmail, window.location.href);
            // mark this session as admin by setting the currentTeam
            window.localStorage.setItem('currentTeam', 'admin');
            window.localStorage.removeItem('adminEmailForSignIn');
            navigate('/review-team-requests');
        } catch (err) {
          setError(err.message || 'Failed to sign in with link.');
          setStatus('error');
        }
      }
    };

    processLink();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('sending');

    try {
      // verify this email is configured as an admin on the server
      const checkAdmin = httpsCallable(functions, 'checkAdminEmail');
      const checkRes = await checkAdmin({ email });
      if (!checkRes.data?.isAdmin) {
        setError('This email is not authorized as an admin.');
        setStatus('error');
        return;
      }

      const actionCodeSettings = {
        url: `${window.location.origin}/admin-login`,
        handleCodeInApp: true,
      };

      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem('adminEmailForSignIn', email);
      // mark pending admin session so review page can detect intent
      window.localStorage.setItem('currentTeam', 'admin');
      setStatus('sent');
    } catch (err) {
      setError(err.message || 'Failed to send admin sign-in link.');
      setStatus('error');
    }
  };

  return (
    <>
      <NavBar pageName="Admin Sign In" showMenu={false} />
      <Container className="my-4">
        <Button variant="link" className="removePadding" onClick={() => navigate('/')}>
          Back to Login
        </Button>
        <Row>
          <Col md={6} lg={5} className="mx-auto">
            <p className="text-muted">Enter your admin email to receive a secure sign-in link.</p>

            {status === 'sent' && (
              <Alert variant="success">Admin sign-in link sent! Check your email and click the link to continue.</Alert>
            )}
            {error && (
              <Alert variant="danger">{error}</Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="admin-email">
                <Form.Label>Admin Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@example.com"
                  required
                />
              </Form.Group>
              <Button type="submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : 'Send Admin Sign-In Link'}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AdminLogin;
